"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
require("./style.css");
var Divider = function Divider(_a) {
  var _b = _a.blockMargin,
    blockMargin = _b === void 0 ? false : _b,
    className = _a.className;
  return react_1.default.createElement("div", {
    className: (0, clsx_1.default)('divider', className, blockMargin && 'divider--with-margin')
  });
};
exports.default = Divider;